//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  methods: {
    selectOption(option) {
      this.$emit('save', {
        key: 'country',
        focusNext: true,
        value: {
          value: option.value,
          textValue: option.label,
        },
      });
    },
    getOptions() {
      return [
        {
          label: this.$t('country.LT'),
          value: 'LT',
        },
        {
          label: this.$t('country.PL'),
          value: 'PL',
        },
      ];
    },
  },
};
